import type { ViewportToolsetPlugin } from "@/viewport-tools/plugin-types";
import type { TagsToolsetRailController } from "@/viewport-tools/rail/types";
import { getTagToolDefinitions, TAG_TOOLSET } from "./registry";
import { TAGS_TOOLSET_RAIL_PLUGIN } from "./rail-plugin";

export const TAGS_VIEWPORT_TOOLSET_PLUGIN: ViewportToolsetPlugin<TagsToolsetRailController> =
  {
  id: TAG_TOOLSET.id,
  toolset: TAG_TOOLSET,
  getTools: () => getTagToolDefinitions(),
  rail: TAGS_TOOLSET_RAIL_PLUGIN,
  };
